class Task {
  constructor(users, groups, objects) {
    this.assignedUsers = users
    this.assignedWorkGroups = groups
    this.objects = objects
  }
}

export { Task as TaskClass }
